import { FC } from 'react';
import { Box, BoxProps, Space } from '@stenajs-webui/core';

export const PopoverBody: FC<BoxProps> = ({ children, ...props }) => (
  <Box indent={3} {...props}>
    {children}
    <Space num={2} />
  </Box>
);
